import { selectPlayerLevelInfo } from "../balancingSelectors/selectBalancingXpLevels";
import { selectPlayerLevel } from "./selectPlayerLevelInfo";
export var selectXpInfo = function (state) {
    var playerLevel = selectPlayerLevel(state);
    return {
        level: selectPlayerLevelInfo(playerLevel),
        nextLevel: selectPlayerLevelInfo(playerLevel + 1),
        xp: selectPlayerXp(state),
    };
};
export var selectPlayerXp = function (state) { return state.playerInfo.xp; };



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectXpInfo.ts
// module id = 433
// module chunks = 3